import { useEffect, useState } from "react";

import Navbar from "../components/Navbar";
import BlogHero from "../components/BlogHero";
import FeaturedBlog from "../components/FeaturedBlog";
import BlogCategoryFilter from "../components/BlogCategoryFilter";
import BlogCard from "../components/BlogCard";
import NewsletterSection from "../components/NewsletterSection";
import Footer from "../components/Footer";
import WhatsAppButton from "../components/WhatsAppButton";

import { getAllBlogs, getFeaturedBlog } from "../firebase/blogService";

const Blog = () => {

    const [blogs, setBlogs] = useState([]);
    const [featuredBlog, setFeaturedBlog] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {

        const loadBlogs = async () => {

            try {

                const featured = await getFeaturedBlog();
                const allBlogs = await getAllBlogs();

                setFeaturedBlog(featured);
                setBlogs(allBlogs);

            } catch (error) {

                console.error(error);

            } finally {

                setLoading(false);

            }

        };

        loadBlogs();

    }, []);

    if (loading) {

        return (
            <>
                <Navbar />
                <div
                    style={{
                        background: "#07111e",
                        color: "#fff",
                        minHeight: "100vh",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}
                >
                    Loading Blogs...
                </div>
            </>
        );

    }

    return (
        <>

            <Navbar />

            <BlogHero />

            {featuredBlog && (

                <FeaturedBlog
                    image={featuredBlog.heroImage || ""}
                    category={featuredBlog.category}
                    title={featuredBlog.title}
                    description={featuredBlog.summary}
                    readTime={featuredBlog.readTime}
                    date={featuredBlog.date}
                />

            )}

            <BlogCategoryFilter />

            <section
                style={{
                    background: "#07111e",
                    paddingBottom: "100px"
                }}
            >

                <div
                    style={{
                        width: "min(1400px,90%)",
                        margin: "0 auto",
                        display: "flex",
                        flexWrap: "wrap",
                        justifyContent: "flex-start",
                        gap: "32px"
                    }}
                >

                    {blogs.map((blog) => (

                        <BlogCard
                            key={blog.id}
                            image={blog.cardImage || ""}
                            category={blog.category}
                            title={blog.title}
                            description={blog.summary}
                            readTime={blog.readTime}
                            date={blog.date}
                            slug={blog.slug}
                        />

                    ))}

                </div>

                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: "60px"
                    }}
                >

                    <button
                        style={{
                            padding: "18px 38px",
                            borderRadius: "14px",
                            border: "1px solid rgba(70,140,255,.18)",
                            background: "#121b38",
                            color: "#19d8ff",
                            cursor: "pointer",
                            fontWeight: "700"
                        }}
                    >
                        Load More Articles →
                    </button>

                </div>

            </section>

            <NewsletterSection />

            <Footer />

            <WhatsAppButton />

        </>
    );

};

export default Blog;